import React, {Component} from  'react';
import PropTypes from 'prop-types';
import animejs from 'animejs';
import classnames from 'classnames';

import ScoreMeter from './ScoreMeter';
import ScoreSubCatIcon from './ScoreSubCatIcon';

const DEFAULT_DURATION = 1500;
//
class ScoreWidget extends Component{
  constructor(props){
    super(props);
    this.componentMounted = false;

  }
  componentWillMount(){
    this.animationValues = {
      overall: 0,
      reviews: 0,
      social: 0,
      listings: 0,
      rankings: 0,
      competitors: 0
    };
  }
  componentWillReceiveProps(nextProps){
    if(nextProps && nextProps.overall !== undefined){
      this.componentMounted = true;
      setTimeout(() => this.startAnimation(), 0);
    }
  }

  componentWillUnmount(){
    this.componentMounted = false;
  }

  shouldComponentUpdate(){
    return !this.componentMounted;
  }

  startAnimation(){
    const duration = this.props.duration || DEFAULT_DURATION;
    switch(this.props.animationStyle){
      case 'together':
        animejs({
          targets: this.animationValues,
          easing: 'linear',
          duration: duration,
          reviews: this.props.reviews,
          social: this.props.social,
          listings: this.props.listings,
          rankings: this.props.rankings,
          competitors: this.props.competitors,
          overall: this.props.overall,
          update: () => {
            this.forceUpdate()
          }
        });
        break;
      case 'stagger':
      default:
        const values = {
          reviews: !!(this.props.reviews),
          social: !!(this.props.social),
          listings: !!(this.props.listings),
          rankings: !!(this.props.rankings),
          competitors: !!(this.props.competitors)
        };
        const halfDuration = duration ;
        const keysWithValues = Object.keys(values).filter(key => values[key]);
        const timeline = animejs.timeline({
          easing: 'linear',
          targets: this.animationValues,
          update: () => {
            this.forceUpdate()
          }
        });
        keysWithValues.forEach(key => timeline.add({
          duration: halfDuration / keysWithValues.length,
          [key]: this.props[key]
        }));
        //start at beginning
        timeline.add({
          targets: this.animationValues,
          duration: duration,
          offset: 0,
          overall: this.props.overall
        });

        timeline.add({
          targets: '.score-delta-container',
          duration: 250,
          opacity: 1
        });
        timeline.add({
          targets: '.scores-widget .text-lg',
          easing: 'easeOutElastic',
          duration: 1000,
          offset: duration,
          fontSize: "105px",
          loop: 1
        });
        break;
    }
  }
  onWidgetClick(showScoreReport) {
    if(showScoreReport){
      window.location.hash = "/scores/summary";
    }
  }
  render(){
    const {user} = this.props;
    let deltaDisplay;

    let showScoreReport = user && user.permissions && user.permissions.indexOf('ShowScoreReport') >= 0
    let scoreWidgetClasses = 'scores-widget' + (showScoreReport ? ' clickable' : '')
    if(typeof this.props.delta !== 'undefined'){
      const deltaPercent = Math.round(this.props.delta * 100)
      let deltaMessage;
      const classes = {"score-delta":  true, "score-delta-positive": deltaPercent > 0, "score-delta-negative": deltaPercent < 0};
      if(deltaPercent !== 0){
        const arrowClasses = {"fa": true, "fa-arrow-up": deltaPercent > 0, "fa-arrow-down": deltaPercent < 0};
        deltaMessage = (
          <span className="message">
            <span key="score-direction" className={classnames(arrowClasses)} /> {deltaPercent}%
          </span>
        )
      } else {
        deltaMessage = "Has not changed"
      }
      deltaDisplay = (
        <div className={classnames(classes)}>
          {deltaMessage} in the last 30 days.
        </div>
      )
    }
    return (
      <div id="score2Widget" className={scoreWidgetClasses} onClick={() => this.onWidgetClick(showScoreReport)}>
        <div className="scores-graph d-flex flex-column">
          <div className="d-flex flex-row justify-content-center">
            <div className="overall-col d-flex justify-content-center align-items-center">
              <ScoreMeter width={140} height={140} score={Math.round(this.animationValues.overall * 100)} />
            </div>
            <div className="subcats-col d-flex justify-content-center align-items-center">
              <ScoreSubCatIcon icon="fas fa-star" tooltip="Reviews" score={Math.round(this.animationValues.reviews * 100)} />
              <ScoreSubCatIcon icon="fas fa-comments" tooltip="Social" score={Math.round(this.animationValues.social * 100)} />
              <ScoreSubCatIcon icon="fas fa-map-marker-alt" tooltip="Listings" score={Math.round(this.animationValues.listings * 100)} />
              <ScoreSubCatIcon icon="far fa-chart-bar" tooltip="Search" score={Math.round(this.animationValues.rankings * 100)} />
              <ScoreSubCatIcon icon="fas fa-trophy" tooltip="Competitors" score={Math.round(this.animationValues.competitors * 100)} />
            </div>
          </div>
          {
            deltaDisplay !== undefined && <div className="score-delta-container content-spacer-top">
              {deltaDisplay}
            </div>
          }
        </div>
        <a className="btn btn-secondary btn-block content-spacer-top" data-analyticsclick="View LBV Details On Snapshot Page" href="#/scores/summary">View Details</a>
      </div>
    )
  }
}


ScoreWidget.propTypes = {
  duration: PropTypes.number,
  easing: PropTypes.string,
  overall: PropTypes.number,
  delta: PropTypes.number,
  reviews: PropTypes.number,
  listings: PropTypes.number,
  rankings: PropTypes.number,
  social: PropTypes.number,
  competitors: PropTypes.number
};
//http://animejs.com/documentation/#penner for easing types
export default ScoreWidget
